import { DatePipe } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { SharedService } from "@shared/services/shared.service";
import { IBusinessFollowUpSiteVisitViewModel, IBusinessInitialSiteVisitViewModel, IBusinessPostRemediationPlanSiteVisitViewModel, IBusinessSiteVisitViewModel } from "app/models/complaints/siteVisit";
import { IAdministrativeComplaintView } from "app/models/mainMenu/mainMenu";
import { ComplaintService } from "app/services/complaint/complaint.service";
import { SiteVisitService } from "app/services/complaint/siteVisit.service";

@Component({
  selector: 'shared-postRemediationEdit',
  styleUrls: ['./postRemediationEdit.component.scss'],
  templateUrl: './postRemediationEdit.component.html'
})

export class PostRemediationEditComponent implements OnInit {

  businessId: number = 0;
  saved: boolean = false;
  showSave: boolean = false;
  reviewed: boolean = false;
  followupInspection: boolean = false;
  siteVisitConducted: boolean = false;
  complaintDueDate: Date = null;

  warningFlag: boolean = false;
  remediationFlag: boolean = false;
  localComplaint: IAdministrativeComplaintView = {} as IAdministrativeComplaintView;

  siteVisitItems: IBusinessSiteVisitViewModel = {} as IBusinessSiteVisitViewModel;
  siteVisit: IBusinessPostRemediationPlanSiteVisitViewModel = {} as IBusinessPostRemediationPlanSiteVisitViewModel;

  form = new UntypedFormGroup({
    postRemediationDate: new UntypedFormControl(Date, [Validators.required]),
    postRemediationConducted: new UntypedFormControl('', [Validators.required]),
    postRemediationResult: new UntypedFormControl(''),
    comments: new UntypedFormControl('')
  });

  constructor(
    private sharedService: SharedService,
    private siteVisitService: SiteVisitService,
    private complaintService: ComplaintService,
    private datePipe: DatePipe,
    private dialogRef: MatDialogRef<PostRemediationEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.siteVisit = this.data.siteVisit;
    this.siteVisitItems = this.siteVisitService.siteVisit;
    this.localComplaint = this.complaintService.currentComplaint;
    if (this.siteVisit != null && this.siteVisit != undefined && this.siteVisit.id != 0) {
      this.setFormData(this.siteVisit);
      this.showSave = true;
    }
    this.businessId = this.localComplaint.businessId;
  }

  ngOnInit(): void {
    this.saved = false;
  }

  save() {
    if (!this.form.valid) {
      this.sharedService.toastr.error("Please fill in all required fields");
      return;
    }
    else {
      this.setSaveData();

      this.siteVisitService.saveSiteVisits(this.businessId, this.siteVisitItems).subscribe({
        next: response => {
          this.sharedService.toastr.success("Saved");
          this.saved = true;
          this.return();
        },
        error: e => {
          this.sharedService.toastr.error("Could not save Site Visit data.");
        },
      });
    }

  }

  siteVisitUpdate(visited: string) {
    this.remediationFlag = visited == '1' ? true : false;
  }

  setSaveData() {
    if (this.form.valid) {
      let data = this.form.value;

      if (this.siteVisit.id == 0) {
        this.siteVisit.complaintId = this.siteVisitService.complaintId;
        this.siteVisit.postRemediationConducted = data.postRemediationConducted;
        this.siteVisit.postRemediationDate = this.datePipe.transform(data.postRemediationDate, 'MM/dd/yyyy');
        this.siteVisit.postRemediationResult = data.postRemediationResult.toString();
        this.siteVisit.comments = data.comments;
        this.siteVisit.allowEditing = true;

        this.siteVisitItems.postRemediationPlanSiteVisits.push(this.siteVisit);
      }
      else {

        let visit = this.siteVisitItems.postRemediationPlanSiteVisits.findIndex(x => x.id == this.siteVisit.id);
        if (visit != null) {
          this.siteVisitItems.postRemediationPlanSiteVisits[visit].postRemediationDate = this.datePipe.transform(data.postRemediationDate, 'MM/dd/yyyy');
          this.siteVisitItems.postRemediationPlanSiteVisits[visit].postRemediationConducted = +data.postRemediationConducted;
          this.siteVisitItems.postRemediationPlanSiteVisits[visit].postRemediationResult = data.postRemediationResult.toString();
          this.siteVisitItems.postRemediationPlanSiteVisits[visit].comments = data.comments;
          this.siteVisitItems.postRemediationPlanSiteVisits[visit].allowEditing = true;
        }
      }
    }
  }

  setFormData(data: IBusinessPostRemediationPlanSiteVisitViewModel) {
    this.form.patchValue({
      postRemediationDate: this.siteVisit.postRemediationDate != null ? new Date(this.siteVisit.postRemediationDate) : '',
      postRemediationConducted: this.siteVisit.postRemediationConducted != null ? this.siteVisit.postRemediationConducted.toString() : '',
      postRemediationResult: this.siteVisit.postRemediationResult,
      comments: this.siteVisit.comments
    });
    this.radioSelected(this.siteVisit.postRemediationResult);
  }

  radioSelected(value: string) {
    if (this.remediationFlag) {
      this.warningFlag = +value > 1;
    }
    else {
      this.warningFlag = false;
    }
  }

  return(): void {
    let returnData = this.saved ? 'saved' : 'cancel';
    this.dialogRef.close(returnData);
  }
}

//'Are you sure you want to create a new follow-up Visit?\n\nFollow-up visits generally are created automatically from initial site visits that have been found to be in violation.\n\nIf you are sure and wish to continue, click OK.\n'